import type { FaireProductEntity } from "../../entity_types/product";

export const p_3sdx5fxw: FaireProductEntity = {
  token: "p_3sdx5fxw",
  type: "product",
  name: "Thank You Leaves Greeting Card (Boxed Set of 6)",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2e7b2b2b9101b3639d7f9c28a8f77d275f1a6e858c90baa2f42dee58d55af2b5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/59f3ef96f0ed57f0300493994d6487a9464506d4db6bb52a5b46a63649ee6e34/1528385733.png",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/1a0e3649d32c88ba47d2111b7671974d0d10559c12d4a7b349b9c57d460a34ce/1528385734.png",
  ],
  priceDollars: 11,
  description:
    "A work of art to show your appreciation. They may want to frame this one.\n\nEach E. Frances card begins as an original watercolor painting, is then printed in brilliant color on luxe, heavyweight paper and is finally kissed with gold foil.\n \nMade in the USA.\nsize\t4.25 X 5.5 INCHES, FOLDED\nfeature\tBLANK INTERIOR\nenvelope color\tSOFT GRAY\nfoil\tMETALLIC GOLD\nitem no.\tTY410",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:03.722Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
